/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Events_KickerInputs */

const en_features_events_kicker = /** @type {(inputs: Features_Events_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classes and workshops`)
};

const pl_features_events_kicker = /** @type {(inputs: Features_Events_KickerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zajęcia i warsztaty`)
};

/**
* | output |
* | --- |
* | "Classes and workshops" |
*
* @param {Features_Events_KickerInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_events_kicker = /** @type {((inputs?: Features_Events_KickerInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Events_KickerInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_events_kicker(inputs)
	return en_features_events_kicker(inputs)
});